import { Component, ojs, app, payload } from "modular-openscriptjs";
import { empty, cleanDispose, eParse, either } from "../../helpers";
import { dom, tool } from "../../fotastart";
import { _UNIQUE_ID_, ACTION_CALLBACKS } from "../../declarations";
import MainActionCanvas from "../Offcanvas/MainActionCanvas";
import SolidIcon from "../Blocks/SolidIcon";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

ojs(MainActionCanvas, SolidIcon);

export default class MainActionForm extends Component {
	holder = null;

	render(name, callbackId, ...args) {
		if (empty(callbackId)) {
			callbackId = _UNIQUE_ID_;
		}

		return h.$(
			h.div(
				{ class: "py-2", maf_hook: `${callbackId}` },
				h.button(
					{
						class: "btn btn-lg btn-dark rounded-pill w-100 px-4 py-3",
						onclick: this.method("runCallback", [callbackId]),
					},
					h.fromString(name, 'span'),
				),
				...args
			)
		);
	}

	runCallback(callbackId) {
		if (!(callbackId in ACTION_CALLBACKS)) return;
		return ACTION_CALLBACKS[callbackId](this, callbackId);
	}

	clearCallback() {
		let elem = this.holder?._element;
		if (!elem) return;
		let d = dom.get(`[maf-hook]`, elem);

		if (!d) return;

		let callbackId = d.getAttribute("maf-hook");
		delete ACTION_CALLBACKS[callbackId];
	}

	async showForm(ed, event) {
		if (this.holder) {
			this.clearCallback();
			cleanDispose(this.holder);
		}

		/**
		 * @type {MainActionData} data
		 */
		const data = eParse(ed).message.get("data", 0);

		this.holder = tool.offcanvas(
			h.MainActionCanvas(
				h.MainActionForm(data.name, data.callbackId, data.attributes)
			),
			either(
				data.closeable,
				h.span(
					{
						class: "text-secondary d-block text-center",
						onclick: this.method("closeForm", [data.callbackId]),
					},
					h.SolidIcon("chevron-down")
				),
				null
			),
			"bottom",
			{
				data_bs_backdrop: false,
				data_bs_scroll: true,
				style: "min-height: auto; max-height: fit-content; max-width: 500px; margin-left: auto; margin-right: auto; z-index:1080;",
				class: "shadow-lg",
			}
		);

		setTimeout(() => {
			this.holder.show();
			broker.send(
				$e.app.mainActionPrompt.shown,
				payload({ callbackId: data.callbackId })
			);
		}, 100);
	}

	closeForm(callbackId = null) {
		if (callbackId) {
			let elem = this.holder?._element;
			if (!elem) return;

			let d = dom.get(`[maf-hook="${callbackId}"]`, elem);

			if (!d) {
				broker.send(
					$e.app.mainActionPrompt.hidden,
					payload({ callbackId })
				);
				return;
			}
		}

		this.holder?.hide();
		this.clearCallback();

		if (callbackId) {
			broker.send(
				$e.app.mainActionPrompt.hidden,
				payload({ callbackId })
			);
		}
	}

	$$app = {
		needs: {
			mainActionPrompt: (ed, event) => this.showForm(ed, event),
			to: {
				closeMainActionPrompt: (ed, event) => this.closeForm(),
			},
		},
	};

	$$ojs = {
		routeChanged: (ed, event) => this.closeForm(),
	};
}
